import { createComponent } from '@carvana/merch-components';
import { Section } from '@/ev-tax-credit/EvTaxCredit.styles';

export const FaqSection = createComponent(Section, {
  className:
    'mx-2xl grid items-start gap-y-4xl pb-6xl pt-3xl sm:mx-3xl sm:py-8xl md:mx-[84px] md:grid-cols-[5fr_7fr] md:gap-x-[132px]'
});

export const StyledQuestion = createComponent('li', {
  className:
    'grid gap-xl border-b border-border-weak py-2xl last-of-type:border-0'
});
